import React from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idCategoriesDelete } from '../../../adminSlice';

export default class DeleteInputForms  extends React.Component {
    constructor(props) {
        super(props);
        
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;

        const item = {
            main_id: this.props.adminState.selectedId,
                       
        }
        console.log(item);
        dispatch(idCategoriesDelete(item));  
}


// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
       return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openDeleteInputForms) {
        return(
            <div className="InputFormsForQuizes">
                <p className='p-text'>id: {this.props.adminState.selectedId}</p>
                <p className='p-text'>Категория: {this.props.adminState.dataCategories.map(item => {
              // console.log(item)
                if (item.id === Number(this.props.adminState.selectedId))
               //console.log(item.label)
                {return item.label;} else {return null;}
                })}
                </p>
                


             <p><b>Вы действительно хотите удалить данную категорию?</b></p>
             <p className='p-text'>(Удалить возможно только <strong> пустую </strong>категорию)</p>
             <button onClick={this.onSend}>Да</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}